import { render, staticRenderFns } from "./DeleteRelation.vue?vue&type=template&id=5235f4bc"
import script from "./DeleteRelation.vue?vue&type=script&lang=js"
export * from "./DeleteRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports